import { Roles } from "../../constants/roles";

import { FormBase } from "../../util/form-base-form";

export class SearchMenuForm extends FormBase {
    public getSubmittedForm(event: Event): HTMLFormElement | null {
        return this.getForm(event);
    }

    public getEventInput(event: Event): HTMLInputElement | null {
        return this.getInput(event);
    }

    public getProductForm(root: ParentNode = document): HTMLFormElement | null {
        return this.queryElement(root, `[data-role="${Roles.PRODUCT_SEARCH_FORM}"]`, HTMLFormElement);
    }

    public getProductForms(root: ParentNode = document): HTMLFormElement[] {
        return this.queryElements(root, `[data-role="${Roles.PRODUCT_SEARCH_FORM}"]`, HTMLFormElement);
    }

    public getBoardForm(root: ParentNode = document): HTMLFormElement | null {
        return this.queryElement(root, `[data-role="${Roles.BOARD_SEARCH_FORM}"]`, HTMLFormElement);
    }

    public getSearchFormInput(root: ParentNode): HTMLInputElement | null {
        return this.queryElement(root, `[data-role="${Roles.SEARCH_FORM_INPUT}"]`, HTMLInputElement);
    }

    public getSearchFormClearButton(root: ParentNode): HTMLButtonElement | null {
        return this.queryElement(root, `[data-role="${Roles.SEARCH_FORM_CLEAR}"]`, HTMLButtonElement);
    }

    public getSubmitButton(root: ParentNode): HTMLButtonElement | null {
        return this.getButton(root, 'button[type="submit"]');
    }

    public getSearchTriggerButton(root: ParentNode): HTMLButtonElement | null {
        return this.queryElement(root, ".btn-search-icon", HTMLButtonElement);
    }

    public getSearchMenuOverlay(root: ParentNode): HTMLElement | null {
        return this.queryElement(root, `[data-role="${Roles.SEARCH_MENU_OVERLAY}"]`, HTMLElement);
    }

    public getSearchMenuContainer(root: ParentNode): HTMLElement | null {
        return this.queryElement(root, `[data-role="${Roles.SEARCH_MENU_CONTAINER}"]`, HTMLElement);
    }

    public getSearchMenuRoot(root: ParentNode): HTMLElement | null {
        return this.queryElement(root, `[data-role="${Roles.SEARCH_MENU_ROOT}"]`, HTMLElement);
    }

    public getSearchMenuScrollBody(root: ParentNode): HTMLElement | null {
        return this.queryElement(root, `[data-role="${Roles.SEARCH_MENU_SCROLL_BODY}"]`, HTMLElement);
    }

    public getSearchMenuPostProductPickerContainer(root: ParentNode = document): HTMLElement | null {
        return this.queryElement(
            root,
            `[data-role="${Roles.SEARCH_MENU_POST_PRODUCT_PICKER_CONTAINER}"][data-search-menu-mode="post-product-picker"]`,
            HTMLElement,
        );
    }

    public getSearchMenuPostProductPickerContainers(root: ParentNode = document): HTMLElement[] {
        return this.queryElements(
            root,
            `[data-role="${Roles.SEARCH_MENU_POST_PRODUCT_PICKER_CONTAINER}"][data-search-menu-mode="post-product-picker"]`,
            HTMLElement,
        );
    }

    public getSearchMenuPersistToggle(root: ParentNode): HTMLInputElement | null {
        return this.queryElement(root, `[data-role="${Roles.SEARCH_MENU_PERSIST_TOGGLE}"]`, HTMLInputElement);
    }

    public getSearchAdvancedToggle(root: ParentNode): HTMLElement | null {
        return this.queryElement(root, `[data-role="${Roles.SEARCH_ADVANCED_TOGGLE}"]`, HTMLElement);
    }

    public getSearchAdvancedPanel(root: ParentNode): HTMLElement | null {
        return this.queryElement(root, `[data-role="${Roles.SEARCH_ADVANCED_PANEL}"]`, HTMLElement);
    }

    public getSearchMenuResults(root: ParentNode): HTMLElement | null {
        return this.queryElement(root, `[data-role="${Roles.SEARCH_MENU_RESULTS}"]`, HTMLElement);
    }

    public getSearchMenuConfirmButton(root: ParentNode): HTMLButtonElement | null {
        return this.queryElement(root, `[data-role="${Roles.SEARCH_MENU_CONFIRM}"]`, HTMLButtonElement);
    }

    public getSearchMenuClearActionButton(root: ParentNode): HTMLButtonElement | null {
        return this.queryElement(root, `[data-role="${Roles.SEARCH_MENU_CLEAR_ACTION}"]`, HTMLButtonElement);
    }

    public getSearchMenuKeywordClearButton(root: ParentNode): HTMLButtonElement | null {
        return this.queryElement(root, `[data-role="${Roles.SEARCH_MENU_KEYWORD_CLEAR}"]`, HTMLButtonElement);
    }

    public getSearchMenuCloseButton(root: ParentNode): HTMLButtonElement | null {
        return this.queryElement(root, `[data-role="${Roles.SEARCH_MENU_CLOSE}"]`, HTMLButtonElement);
    }

    public getSearchMenuTargetInput(root: ParentNode): HTMLInputElement | null {
        return this.queryElement(root, `[data-role="${Roles.SEARCH_MENU_TARGET}"]`, HTMLInputElement);
    }

    public getSearchMenuTargetFieldGroup(root: ParentNode): HTMLElement | null {
        return this.queryElement(root, `[data-role="${Roles.SEARCH_MENU_TARGET_FIELD_GROUP}"]`, HTMLElement);
    }

    public getAdvancedTabPanel(root: ParentNode, tabKey: string): HTMLElement | null {
        return this.queryElement(
            root,
            `[data-role="${Roles.SEARCH_ADVANCED_TAB_PANEL}"][data-panel="${tabKey}"]`,
            HTMLElement,
        );
    }

    public getActiveAdvancedTabPanel(root: ParentNode): HTMLElement | null {
        return (
            this.queryElement(root, `[data-role="${Roles.SEARCH_ADVANCED_TAB_PANEL}"].is-active`, HTMLElement) ||
            this.queryElement(
                root,
                `[data-role="${Roles.SEARCH_ADVANCED_TAB_PANEL}"][data-panel="products"]`,
                HTMLElement,
            )
        );
    }

    public getAllAdvancedTabPanels(root: ParentNode): HTMLElement[] {
        return this.queryElements(root, `[data-role="${Roles.SEARCH_ADVANCED_TAB_PANEL}"]`, HTMLElement);
    }

    public getAllAdvancedTabs(root: ParentNode): HTMLElement[] {
        return this.queryElements(root, `[data-role="${Roles.SEARCH_ADVANCED_TAB}"]`, HTMLElement);
    }

    public getNamedInput(root: ParentNode, name: string): HTMLInputElement | null {
        return this.queryElement(root, `[name="${name}"]`, HTMLInputElement);
    }

    public getNamedHiddenInput(root: ParentNode, name: string): HTMLInputElement | null {
        return this.queryElement(root, `input[type="hidden"][name="${name}"]`, HTMLInputElement);
    }

    public getNamedCheckbox(root: ParentNode, name: string): HTMLInputElement | null {
        return this.queryElement(root, `input[type="checkbox"][name="${name}"]`, HTMLInputElement);
    }

    public getChoicesSelect(root: ParentNode, name: string): HTMLSelectElement | null {
        return this.queryElement(
            root,
            `[data-choices-bind-to="${name}"] select[data-choices-control]`,
            HTMLSelectElement,
        );
    }

    public getSearchMenuInputs(root: ParentNode = document): HTMLInputElement[] {
        return this.queryElements(
            root,
            `[data-role="${Roles.SEARCH_FORM_INPUT}"][data-search-menu-mode], input[name="query"][data-search-menu-mode], input[data-search-menu-mode]`,
            HTMLInputElement,
        );
    }

    public getClosestSetProductButton(target: Element | null | undefined): HTMLButtonElement | null {
        return this.closest(target, `[data-role="${Roles.SEARCH_MENU_SET_PRODUCT}"]`, HTMLButtonElement);
    }

    public getClosestChoicesDropdown(target: Element | null | undefined): HTMLElement | null {
        return this.closest(target, ".choices__list--dropdown", HTMLElement);
    }

    public getClosestCategoryModal(target: Element | null | undefined): HTMLElement | null {
        return this.closest(
            target,
            `[data-role="${Roles.SEARCH_CATEGORY_MODAL}"], [data-role="${Roles.SEARCH_CATEGORY_MODAL_OVERLAY}"]`,
            HTMLElement,
        );
    }

    public getClosestBrandModal(target: Element | null | undefined): HTMLElement | null {
        return this.closest(
            target,
            `[data-role="${Roles.SEARCH_BRAND_MODAL}"], [data-role="${Roles.SEARCH_BRAND_MODAL_OVERLAY}"]`,
            HTMLElement,
        );
    }

    public getClosestCategoryReviewEditor(target: Element | null | undefined): HTMLElement | null {
        return this.closest(
            target,
            `[data-role="${Roles.CATEGORY_REVIEW_EDITOR_MODAL}"], [data-role="${Roles.CATEGORY_REVIEW_EDITOR_OVERLAY}"]`,
            HTMLElement,
        );
    }

    public getChoicesSelects(root: ParentNode): HTMLSelectElement[] {
        return this.queryElements(root, "select[data-choices-control]", HTMLSelectElement);
    }

    /** Whether the category icon sprite (rendered once in layouts/app.blade.php) defines this <symbol> id. */
    public hasCategoryIconSymbol(symbolId: string): boolean {
        // <symbol> is an SVGElement, not an HTMLElement — DomQuery.queryElement()
        // defaults to accepting only HTMLElement/HTMLFormElement, so the expected
        // class must be passed explicitly or a real match is silently rejected.
        return this.queryElement(document, `#${symbolId}`, SVGElement) !== null;
    }
}
